import APIServer from './APIServer'
import UtilsManager from '../managers/UtilsManager'

export default class HighlightAPI extends APIServer { 

	constructor() {
		super()
		this.utilsManager = new UtilsManager()
	}

	async getActiveHighlight(domain = null) {
		var url = "/highlight/active"
		const params = []
		if (domain !== null) {
			params.push({
				title: 'zone',
				value: domain
			})
		}

		url += this.utilsManager.combineParams(params)
		return await super.get(url)
	}
}